import {State} from '../../auth/modules/selectors'

const languageToCountryCodeMapping: Record<string, string> = {
  ar: 'ar-arl',
  cs: 'cz',
  da: 'dk',
  de: 'de',
  en: 'us',
  'en-GB': 'gb',
  es: 'es',
  fi: 'fi',
  fr: 'fr',
  he: 'il',
  hu: 'hu',
  id: 'id',
  it: 'it',
  ja: 'jp',
  ko: 'kr',
  ms: 'my',
  nl: 'nl',
  no: 'no',
  pl: 'pl',
  'pt-BR': 'br',
  pt: 'pt',
  ro: 'ro',
  ru: 'ru',
  sv: 'se',
  th: 'th',
  tr: 'tr',
  uk: 'ua',
  'zh-HK': 'hk',
  'zh-TW': 'tw',
  zh: 'cn',
  'fr-CA': 'ca',
  el: 'gr',
  vi: 'vn'
  // hi: 'in',
  // mr: 'in'
  // bn: 'in',
  // 'es-AR': 'ar',
  // 'es-CL': 'cl',
  // 'es-CO': 'co',
  // 'es-CR': 'cr',
  // 'es-EC': 'ec',
  // 'es-GT': 'gt',
  // 'es-MX': 'mx',
  // 'es-PA': 'pa',
  // 'es-PY': 'py',
  // 'es-PE': 'pe',
  // 'es-PR': 'pr',
  // 'es-DO': 'do',
  // 'es-UY': 'uy',
  // 'es-VE': 've'
}

/**
 * Returns the mapped country code for the specified language code.
 * @param languageCode
 * @returns Matching country code
 */
export const getCountryCodeFromLanguage = (languageCode: string) =>
  languageToCountryCodeMapping[languageCode]

/**
 * Returns a set of country codes that use 12-hour format.
 * @returns Set of country codes that use 12-hour format
 */
export const countriesThatUse12HourFormat = new Set([
  'US',
  'CA',
  'NZ',
  'AU',
  'PH'
])

export const getCountryCode = (state: State) => state.meta.userCountryCode
